import * as React from 'react';
import { Heading, List, ListItem, Stack, Text, TextLink } from '@origin-digital/ods-core';

export const BattMaxEligibilityCriteriaModal = (
  <Stack data-id="plan-key-details-info-modal">
    <Heading variant="h3">Confirm your eligibility</Heading>
    <Stack space="xxsmall">
      <Text>
        Before signing up check to see if your solar system, battery and inverter are eligible.  If
        you do not meet the eligibility requirements or do not provide details of an eligible
        battery, your energy plan will continue, but you will not receive the benefits of VPP
        orchestration.
      </Text>
      <Text weight="medium">To be eligible, you need to:</Text>
      <List space="xxsmall">
        <ListItem>
          <Text variant="body-small">Have a smart meter at the installation address</Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            Have an operational solar system size between 5kWh and 20kWh
          </Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            Have a battery that’s available and online for at least 90% of the month
          </Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            Have solar data that’s accessible via Origins connection to the inverter
          </Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            Have broadband services at the installation address with reliable and consistent WiFi
            that your system inverter is connected to
          </Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            Have your solar and battery system connected to the internet
          </Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">Live in NSW, SA, VIC, QLD.</Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">Not have life support requirements at the site</Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">Not be part of another Virtual Power Plant</Text>
        </ListItem>
        <ListItem>
          <Text variant="body-small">
            Have a{' '}
            <TextLink
              href={
                'https://www.originenergy.com.au/help-support/energy-products-and-services/batteries-and-loop-vpp/compatible-solar-batteries-and-inverter-models'
              }
              target="_blank"
            >
              compatible battery and inverter
            </TextLink>
          </Text>
        </ListItem>
      </List>
    </Stack>
  </Stack>
);
